import React, { useState } from 'react'
import {
  Button,
  ModalHeader,
  ModalBody,
} from 'reactstrap';

import Brands from './Brands'
import ExpoMagazine from './ExpoMagazine'
import Speaker from './NewSpeaker'
import PortalMatchmaking from './PortalMatchmaking';
import YourUpload from './YourUpload'
import Lang from 'Lang/General'

import { TabOptions } from './assets'

function UploadModalContent(props) {
  const [currentTab, setCurrentTab] = useState(TabOptions(props.selectedPortalUsers)?.[0]?.value)

  return (
    <>
      <ModalHeader toggle={() => props.onClose()}>
        {
          props.selectedPortalUsers?.company_name ?? ''
        }
      </ModalHeader>
      <ModalBody>
        <div className="d-flex flex-wrap" style={{ gap: 10 }}>
          {
            TabOptions(props.selectedPortalUsers).map(option => (
              <Button
                color={currentTab === option.value ? 'primary' : 'secondary'}
                onClick={() => setCurrentTab(option.value)}
              >
                {Lang[option.label][props.data.languageReducer.userSettings.admin_panel_language]}
              </Button>
            ))
          }
        </div>
        {
          currentTab === 'expo_magazine' && (
            <ExpoMagazine {...props} />
          )
        }
        {
          currentTab === 'your_upload' && (
            <YourUpload {...props} />
          )
        }
        {
          currentTab === 'brands' && (
            <Brands {...props} />
          )
        }
        {
          currentTab === 'speakers' && (
            <Speaker {...props} />
          )
        }
        {
          currentTab === 'match_making' && (
            <PortalMatchmaking {...props} />
          )
        }
      </ModalBody>
    </>
  )
}

export default UploadModalContent